// Filename: public/wellBeingGoals.js

import wixData from 'wix-data';
import { local } from "wix-storage-frontend";
import { updateUserWellBeingGoals } from 'backend/wellBeingGoals';

// Async function to get recommendations for selected goals
export async function getRecommendationsForGoals(selectedGoals) {
    try {
        //console.log('selectedGoals...', selectedGoals);

        const result = await wixData.query("QuizRecommendationEngine")
            .hasSome("wellbeingGoal", selectedGoals)
            .find();

        const allResults = result.items;
        //console.log('allResults...', allResults);

        const flattenedData = [];

        allResults.forEach(item => {
            const goal = item.wellbeingGoal;
            const weights = item.recommendationWeight || {};

            Object.entries(weights).forEach(([quiz, weight]) => {
                flattenedData.push({ goal, quiz: quiz.trim(), weight });
            });
        });

        //console.log('flattenedData...', flattenedData);

        return calculateQuizRanks(selectedGoals, flattenedData);
    } catch (error) {
        console.error('Error in getRecommendationsForGoals:', error);
        throw error; // rethrow or handle depending on your use case
    }
}

// Function to calculate quiz rank
function calculateQuizRanks(selectedGoals, data) {
    try {
        const quizRanks = {};

        data.forEach(entry => {
            if (selectedGoals.includes(entry.goal)) {
                if (!quizRanks[entry.quiz]) {
                    quizRanks[entry.quiz] = 0;
                }
                quizRanks[entry.quiz] += entry.weight;
            }
        });
        //console.log('quizRanks...', quizRanks);

        // const sortedRanks = Object.entries(quizRanks)
        //     .sort((a, b) => b[1] - a[1])
        //     .map(([quiz, totalWeight]) => ({ quiz, totalWeight }));
        // console.log('sortedRanks...', sortedRanks);

        return quizRanks;
    } catch (error) {
        console.error('Error in calculateQuizRanks:', error);
        return [];
    }
}

// Function to check selected goals from session
export async function checkAndUpdateSelectedGoals(wixId, selectedWellBeingGoalsIds) {

    await updateUserWellBeingGoals(wixId, selectedWellBeingGoalsIds.toString()) //selectedGoalsIDS.toString()
        .then((data) => {
            console.log('contact updated with selected goals', data);
            if (data) {
                local.removeItem("wellBeingGoals");
            }
        })
        .catch((error) => {
            console.log(error);
        });

}

// Function to get all Well-Being goals from collection
export async function fetchAllWellBeingGoals() {
    try {
        const result = await wixData.query("QuizRecommendationEngine").find();
        const data = result.items.sort((a, b) => a.order - b.order);
        return data;
    } catch (error) {
        console.error('Error fetching Well-Being goals:', error);
        return [];
    }
}